import { Box } from 'ui/Box';
import { FC } from 'react';
import { Typography } from '@mui/material';
import { Button } from 'components/Button';
import { appRoutes } from 'utils';
import { useNavigate } from 'react-router-dom';
export interface Step9Props {}
export const Step9: FC<Step9Props> = () => {
  const navigate = useNavigate();

  const onButtonClick = () => {
    navigate(appRoutes.workspace);
  };

  return (
    <Box className="flex flex-1 flex-col items-center justify-center text-center">
      <Typography variant="h1Secondary" className="text-black">
        Thanks for filling information!
      </Typography>
      <Typography className="mb-12 mt-6 max-w-[646px] text-center text-dark">
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rem ducimus
        illo, repellendus neque accusamus alias id voluptatum at! Earum
        doloribus aliquam ratione repellendus illum temporibus soluta ea
        tenetur, blanditiis libero.
      </Typography>
      <Button
        onClick={onButtonClick}
        className="w-full max-w-full md:max-w-max"
      >
        <Typography>Go to my Workspace</Typography>
      </Button>
    </Box>
  );
};
